export default __webpack_public_path__ + "static/media/academics-base-with-text.051ceb53.jpg";